/* Designer Consignor Naples — modal.js
   Contextual modal (content adapts to the trigger) + themed brass click-burst. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var CONTEXTS = {
    consign: {
      eyebrow: 'Sell With Us',
      title: 'Begin your consignment',
      intro: 'Tell us about your piece and our team will follow up with an estimate within 1–2 business days.',
      context: 'Consignment inquiry'
    },
    inhome: {
      eyebrow: 'In-Home Consignment',
      title: 'Request an in-home appointment',
      intro: 'Tell us a little about your collection and we will reach out to schedule a convenient time to come to you.',
      context: 'In-home consignment appointment request'
    },
    viewing: {
      eyebrow: 'Visit the Boutique',
      title: 'Plan your visit',
      intro: 'We are open Monday to Saturday, 10 to 4, in St. Andrews Square. Have a question before you come in? Send us a note and we will get right back to you.',
      context: 'Visit inquiry'
    }
  };

  function initModal() {
    var modal = $('[data-cmodal]');
    if (!modal) return;
    var panel = $('.cmodal__panel', modal);
    var elEyebrow = $('[data-cmodal-eyebrow]', modal);
    var elTitle = $('[data-cmodal-title]', modal);
    var elIntro = $('[data-cmodal-intro]', modal);
    var elContext = $('[data-cmodal-context]', modal);
    var lastFocused = null;

    function open(trigger) {
      var ctxKey = (trigger && trigger.getAttribute('data-modal')) || 'consign';
      var preset = CONTEXTS[ctxKey] || CONTEXTS.consign;
      if (elEyebrow) elEyebrow.textContent = trigger.getAttribute('data-modal-eyebrow') || preset.eyebrow;
      if (elTitle) elTitle.textContent = trigger.getAttribute('data-modal-title') || preset.title;
      if (elIntro) elIntro.textContent = trigger.getAttribute('data-modal-intro') || preset.intro;
      if (elContext) elContext.value = preset.context;

      lastFocused = document.activeElement;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = $('input, textarea, button', panel);
      if (first) first.focus();
    }
    function close() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    $all('[data-modal]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); open(t); });
    });
    $all('[data-cmodal-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
      if (e.key === 'Tab' && modal.classList.contains('open')) {
        var f = $all('a[href], button:not([disabled]), input, textarea, select', panel).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // Re-open to show success after a contact-form post reload, but only when THIS form posted
    // (Shopify flags every contact form on the page as posted; the redirect hash names the real one).
    var success = $('[data-cmodal-success]', modal);
    if (success) {
      if (!location.hash || location.hash === '#cmodal-form') {
        modal.classList.add('open');
        modal.setAttribute('aria-hidden', 'false');
      } else {
        success.style.display = 'none';
      }
    }
  }

  /* Themed brass click-burst on buttons */
  function initBurst() {
    if (reduced) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn');
      if (!btn) return;
      var b = document.createElement('span');
      b.className = 'brass-burst';
      b.style.left = e.clientX + 'px';
      b.style.top = e.clientY + 'px';
      b.innerHTML = '<i></i><i></i><b></b>';
      document.body.appendChild(b);
      setTimeout(function () { b.parentNode && b.parentNode.removeChild(b); }, 700);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initModal(); initBurst(); });
})();
